/**
 * IIAB EXPO 2027 - Pavilion 3 Floor Plan Geometry & Data
 * Jio World Convention Centre (JWCC), BKC, Bandra East, Mumbai, India
 */

export interface StallGeometry {
  id: string;
  dimensions: string;
  areaSqm: number;
  priceInr: number;
  category: 'shell_9' | 'premium_12' | 'grand_18' | 'island_36' | 'trading_table' | 'meeting_room' | 'facility';
  x: number;
  y: number;
  w: number;
  h: number;
  initialStatus: 'available' | 'on_hold' | 'booked' | 'reserved';
}

export interface FacilityZone {
  id: string;
  title: string;
  dimensions: string;
  areaText: string;
  x: number;
  y: number;
  w: number;
  h: number;
  type: 'cafeteria' | 'conference' | 'registration' | 'organizer' | 'turnstile';
}

export interface PillarMarker {
  cx: number;
  cy: number;
  r: number;
}

export const FLOORPLAN_DIMENSIONS = {
  viewBox: '0 0 724 920',
  width: 724,
  height: 920,
  hallBounds: { x: 42, y: 170, w: 640, h: 710 },
};

export const STALLS_DATA: StallGeometry[] = [
  {
    "id": "SB22",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 207,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB21",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 236,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB20",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 265,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB19",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 294,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB18",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 323,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB17",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 352,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB16",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 381,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB15",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 410,
    "w": 29,
    "h": 29,
    "initialStatus": "on_hold"
  },
  {
    "id": "SB14",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB13",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 507,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB12",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 536,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB11",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 53,
    "y": 565,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB10",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 53,
    "y": 594,
    "w": 39,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB31",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 112,
    "y": 236,
    "w": 29,
    "h": 29,
    "initialStatus": "booked"
  },
  {
    "id": "SB40",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 141,
    "y": 236,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB30",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 112,
    "y": 265,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB39",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 141,
    "y": 265,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB29",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 112,
    "y": 323,
    "w": 39,
    "h": 29,
    "initialStatus": "booked"
  },
  {
    "id": "SB38",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 151,
    "y": 323,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB28",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 112,
    "y": 352,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB37",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 151,
    "y": 381,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB27",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 112,
    "y": 381,
    "w": 39,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB36",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 151,
    "y": 410,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB26",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 112,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB35",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 141,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB25",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 112,
    "y": 507,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB34",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 141,
    "y": 507,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB24",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 112,
    "y": 536,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB33",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 141,
    "y": 536,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "GB23",
    "dimensions": "6x3m",
    "areaSqm": 18,
    "priceInr": 175000,
    "category": "grand_18",
    "x": 112,
    "y": 565,
    "w": 29,
    "h": 58,
    "initialStatus": "booked"
  },
  {
    "id": "GB32",
    "dimensions": "6x3m",
    "areaSqm": 18,
    "priceInr": 175000,
    "category": "grand_18",
    "x": 141,
    "y": 565,
    "w": 29,
    "h": 58,
    "initialStatus": "available"
  },
  {
    "id": "SB49",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 199,
    "y": 236,
    "w": 29,
    "h": 29,
    "initialStatus": "booked"
  },
  {
    "id": "SB58",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 228,
    "y": 236,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB48",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 199,
    "y": 265,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB57",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 228,
    "y": 265,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB47",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 194,
    "y": 323,
    "w": 34,
    "h": 29,
    "initialStatus": "on_hold"
  },
  {
    "id": "PB56",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 228,
    "y": 323,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB46",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 199,
    "y": 352,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB55",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 228,
    "y": 352,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB45",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 194,
    "y": 381,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB54",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 228,
    "y": 381,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB44",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 199,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB53",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 228,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB43",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 194,
    "y": 507,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB52",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 228,
    "y": 507,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB42",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 199,
    "y": 536,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB51",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 228,
    "y": 536,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "GB41",
    "dimensions": "6x3m",
    "areaSqm": 18,
    "priceInr": 175000,
    "category": "grand_18",
    "x": 199,
    "y": 565,
    "w": 29,
    "h": 58,
    "initialStatus": "available"
  },
  {
    "id": "GB50",
    "dimensions": "6x3m",
    "areaSqm": 18,
    "priceInr": 175000,
    "category": "grand_18",
    "x": 228,
    "y": 565,
    "w": 29,
    "h": 58,
    "initialStatus": "on_hold"
  },
  {
    "id": "SB65",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 286,
    "y": 236,
    "w": 29,
    "h": 29,
    "initialStatus": "on_hold"
  },
  {
    "id": "SB72",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 315,
    "y": 236,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB64",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 286,
    "y": 265,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB71",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 315,
    "y": 265,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB63",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 281,
    "y": 323,
    "w": 34,
    "h": 29,
    "initialStatus": "booked"
  },
  {
    "id": "PB70",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 315,
    "y": 323,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB62",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 286,
    "y": 352,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB69",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 315,
    "y": 352,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB61",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 281,
    "y": 381,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB68",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 315,
    "y": 381,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB60",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 286,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB67",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 315,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB59",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 281,
    "y": 507,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB66",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 315,
    "y": 507,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "DB8",
    "dimensions": "6x6m",
    "areaSqm": 36,
    "priceInr": 360000,
    "category": "island_36",
    "x": 286,
    "y": 568,
    "w": 58,
    "h": 57,
    "initialStatus": "available"
  },
  {
    "id": "PB77",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 369,
    "y": 323,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB82",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 403,
    "y": 323,
    "w": 34,
    "h": 29,
    "initialStatus": "on_hold"
  },
  {
    "id": "SB76",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 374,
    "y": 352,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB81",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 403,
    "y": 352,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB75",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 369,
    "y": 381,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB80",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 403,
    "y": 381,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB74",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 374,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "booked"
  },
  {
    "id": "SB79",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 403,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB73",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 369,
    "y": 507,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB78",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 403,
    "y": 507,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "DB9",
    "dimensions": "6x6m",
    "areaSqm": 36,
    "priceInr": 360000,
    "category": "island_36",
    "x": 374,
    "y": 568,
    "w": 58,
    "h": 57,
    "initialStatus": "available"
  },
  {
    "id": "PB89",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 457,
    "y": 323,
    "w": 34,
    "h": 29,
    "initialStatus": "booked"
  },
  {
    "id": "SB94",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 491,
    "y": 323,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB88",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 462,
    "y": 352,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB87",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 457,
    "y": 381,
    "w": 34,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "VIP-LOUNGE",
    "dimensions": "6x3m",
    "areaSqm": 18,
    "priceInr": 175000,
    "category": "facility",
    "x": 491,
    "y": 365,
    "w": 29,
    "h": 45,
    "initialStatus": "reserved"
  },
  {
    "id": "SB86",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 462,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB93",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 491,
    "y": 478,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB85",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 462,
    "y": 507,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB92",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 491,
    "y": 507,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB84",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 462,
    "y": 536,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB91",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 491,
    "y": 536,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "GB83",
    "dimensions": "6x3m",
    "areaSqm": 18,
    "priceInr": 175000,
    "category": "grand_18",
    "x": 462,
    "y": 565,
    "w": 29,
    "h": 58,
    "initialStatus": "available"
  },
  {
    "id": "GB90",
    "dimensions": "6x3m",
    "areaSqm": 18,
    "priceInr": 175000,
    "category": "grand_18",
    "x": 491,
    "y": 565,
    "w": 29,
    "h": 58,
    "initialStatus": "available"
  },
  {
    "id": "SB98",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 550,
    "y": 536,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "SB95",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "shell_9",
    "x": 579,
    "y": 536,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "PB96",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 550,
    "y": 565,
    "w": 29,
    "h": 40,
    "initialStatus": "available"
  },
  {
    "id": "PB97",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 579,
    "y": 565,
    "w": 29,
    "h": 40,
    "initialStatus": "available"
  },
  {
    "id": "PB100",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 628,
    "y": 536,
    "w": 34,
    "h": 34,
    "initialStatus": "booked"
  },
  {
    "id": "PB99",
    "dimensions": "4x3m",
    "areaSqm": 12,
    "priceInr": 115000,
    "category": "premium_12",
    "x": 628,
    "y": 571,
    "w": 34,
    "h": 34,
    "initialStatus": "available"
  },
  {
    "id": "DB1",
    "dimensions": "6x6m",
    "areaSqm": 36,
    "priceInr": 360000,
    "category": "island_36",
    "x": 72,
    "y": 655,
    "w": 58,
    "h": 58,
    "initialStatus": "booked"
  },
  {
    "id": "DB2",
    "dimensions": "6x6m",
    "areaSqm": 36,
    "priceInr": 360000,
    "category": "island_36",
    "x": 160,
    "y": 655,
    "w": 58,
    "h": 58,
    "initialStatus": "available"
  },
  {
    "id": "DB3",
    "dimensions": "6x6m",
    "areaSqm": 36,
    "priceInr": 360000,
    "category": "island_36",
    "x": 248,
    "y": 655,
    "w": 58,
    "h": 58,
    "initialStatus": "available"
  },
  {
    "id": "DB4",
    "dimensions": "6x6m",
    "areaSqm": 36,
    "priceInr": 360000,
    "category": "island_36",
    "x": 335,
    "y": 655,
    "w": 58,
    "h": 58,
    "initialStatus": "on_hold"
  },
  {
    "id": "DB5",
    "dimensions": "6x6m",
    "areaSqm": 36,
    "priceInr": 360000,
    "category": "island_36",
    "x": 422,
    "y": 655,
    "w": 58,
    "h": 58,
    "initialStatus": "available"
  },
  {
    "id": "DB6",
    "dimensions": "6x6m",
    "areaSqm": 36,
    "priceInr": 360000,
    "category": "island_36",
    "x": 510,
    "y": 655,
    "w": 58,
    "h": 58,
    "initialStatus": "available"
  },
  {
    "id": "DB7",
    "dimensions": "6x6m",
    "areaSqm": 36,
    "priceInr": 360000,
    "category": "island_36",
    "x": 598,
    "y": 655,
    "w": 58,
    "h": 58,
    "initialStatus": "booked"
  },
  {
    "id": "MR-1",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "meeting_room",
    "x": 112,
    "y": 172,
    "w": 29,
    "h": 29,
    "initialStatus": "booked"
  },
  {
    "id": "MR-2",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "meeting_room",
    "x": 141,
    "y": 172,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "MR-3",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "meeting_room",
    "x": 170,
    "y": 172,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "MR-4",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "meeting_room",
    "x": 215,
    "y": 172,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "MR-5",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "meeting_room",
    "x": 244,
    "y": 172,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "MR-6",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "meeting_room",
    "x": 305,
    "y": 172,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "MR-7",
    "dimensions": "3x3m",
    "areaSqm": 9,
    "priceInr": 85000,
    "category": "meeting_room",
    "x": 334,
    "y": 172,
    "w": 29,
    "h": 29,
    "initialStatus": "available"
  },
  {
    "id": "TT1",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 481,
    "y": 724,
    "w": 26,
    "h": 20,
    "initialStatus": "booked"
  },
  {
    "id": "TT2",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 511,
    "y": 724,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  },
  {
    "id": "TT3",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 541,
    "y": 724,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  },
  {
    "id": "TT12",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 481,
    "y": 756,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  },
  {
    "id": "TT11",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 511,
    "y": 756,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  },
  {
    "id": "TT10",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 541,
    "y": 756,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  },
  {
    "id": "TT4",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 588,
    "y": 724,
    "w": 26,
    "h": 20,
    "initialStatus": "on_hold"
  },
  {
    "id": "TT5",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 618,
    "y": 724,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  },
  {
    "id": "TT6",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 648,
    "y": 724,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  },
  {
    "id": "TT9",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 588,
    "y": 756,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  },
  {
    "id": "TT8",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 618,
    "y": 756,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  },
  {
    "id": "TT7",
    "dimensions": "3x2m",
    "areaSqm": 6,
    "priceInr": 55000,
    "category": "trading_table",
    "x": 648,
    "y": 756,
    "w": 26,
    "h": 20,
    "initialStatus": "available"
  }
];

export const FACILITIES_DATA: FacilityZone[] = [
  {
    id: 'cafeteria',
    title: 'CAFETERIA',
    dimensions: '31m x 12m',
    areaText: '472 sqm',
    x: 374,
    y: 189,
    w: 299,
    h: 114,
    type: 'cafeteria',
  },
  {
    id: 'conference-hall',
    title: 'CONFERENCE HALL',
    dimensions: '23m x 13m',
    areaText: '299 sqm',
    x: 546,
    y: 308,
    w: 127,
    h: 215,
    type: 'conference',
  },
  {
    id: 'registration',
    title: 'REGISTRATION',
    dimensions: '12m x 3m',
    areaText: '36 sqm',
    x: 335,
    y: 745,
    w: 115,
    h: 30,
    type: 'registration',
  },
  {
    id: 'secretariat',
    title: 'SECRETARIAT',
    dimensions: '3m x 3m',
    areaText: 'Secretariat Helpdesk',
    x: 450,
    y: 745,
    w: 25,
    h: 30,
    type: 'registration',
  },
  {
    id: 'organizer-office',
    title: 'ORGANIZER OFFICE',
    dimensions: '6m x 3m',
    areaText: '18 sqm',
    x: 53,
    y: 686,
    w: 58,
    h: 34,
    type: 'organizer',
  },
];

export const PILLARS_DATA: PillarMarker[] = [
  { cx: 151, cy: 352, r: 10 },
  { cx: 491, cy: 352, r: 10 },
  { cx: 160, cy: 630, r: 10 },
  { cx: 510, cy: 630, r: 10 },
];

export const STALL_GEOMETRY_MAP: Record<string, StallGeometry> = Object.fromEntries(
  STALLS_DATA.map((s) => [s.id, s])
);
